module.exports = __webpack_public_path__ + "static/media/img-mulher.414fffaf.svg";